import React, { useState } from 'react'
import { Col, Row } from 'reactstrap'
import { useAuth0 } from '@auth0/auth0-react';
import axios from 'axios';
import { Button, Modal, Box, Typography, IconButton } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTicket, faInfoCircle } from '@fortawesome/free-solid-svg-icons';

export const TourItem = (props) => {
    const { isAuthenticated } = useAuth0();
    const matches = useMediaQuery('(max-width:400px)');
    const [openModal, setOpenModal] = useState(false);

    const handleDelete = async() => {
        await axios.delete(`/api/tour/${props.id}`)
        props.refreshTour();
    }

    const handleOpenModal = () => {
        setOpenModal(true);
    };

    const handleCloseModal = () => {
        setOpenModal(false);
    };

    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: matches ? '90%' : '75%',
        bgcolor: '#1a1a1a',
        border: '2px solid #333',
        boxShadow: 24,
        p: 4,
        borderRadius: 2,
        color: 'white',
    };

    const mobileTourItem = () => {
        console.log(matches)
        return (
            <div className='tour-item' style={{ position: 'relative' }}>
                <IconButton 
                    onClick={handleOpenModal} 
                    style={{ 
                        position: 'absolute', 
                        top: '5px', 
                        right: '5px',
                        zIndex: 1
                    }}
                >
                    <FontAwesomeIcon icon={faInfoCircle} color='white' />
                </IconButton>
                <h5>Date: {props.date}</h5>
                <h5>Venue: {props.venue}</h5>
                <h5>Info: {props.info}</h5>
                <h5 className='text-bold'>
                    <a href={props.ticketLink} target='blank' className='ticket'>
                        <FontAwesomeIcon icon={faTicket} color='white' />
                    </a>
                </h5>
            </div>
        )
    }
  return (
    <>
    {matches ? mobileTourItem() :
    <div className='tour-item' style={{ position: 'relative' }}>
        <IconButton 
            onClick={handleOpenModal} 
            style={{ 
                position: 'absolute', 
                top: '5px', 
                right: '5px',
                zIndex: 1
            }}
        >
            <FontAwesomeIcon icon={faInfoCircle} size='sm' color='white' />
        </IconButton>
        <Row>
            <Col>
                <p>{props.date}</p>
            </Col>
            <Col>
                <p>{props.venue}</p>
            </Col>
            <Col>
                <p>{props.info}</p>
            </Col>
            <Col>
                <p className='text-bold'>
                    <a href={props.ticketLink} target='blank' className='ticket'>
                        <FontAwesomeIcon icon={faTicket} size='xl' />
                    </a>
                </p>
            </Col>
            { isAuthenticated && 
            <Col>
                <Button variant="contained" color="secondary" onClick={handleDelete}>Delete</Button>
            </Col>
            }
        </Row>
    </div>
    }
    
    <Modal
        open={openModal}
        onClose={handleCloseModal}
        aria-labelledby="tour-details-modal"
        aria-describedby="tour-details-description"
    >
        <Box sx={modalStyle}>
            <Typography id="tour-details-modal" variant="h5" component="h2" gutterBottom>
                {props.title}
            </Typography>
            <Typography id="tour-details-description" variant="body1" sx={{ mt: 2 }}>
                {props.description || 'No description available.'}
            </Typography>
            <Typography id="tour-details-description" variant="body1" sx={{ mt: 2 }}>
                Get tickets <a href={props.ticketLink} target='blank'>here</a>
            </Typography>
            <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>
                <Button onClick={handleCloseModal} variant="contained" color="primary">
                    Close
                </Button>
            </Box>
        </Box>
    </Modal>
    </>
  )
}
